import { useEffect, useRef } from "react";
type Props = { symbol?: string; height?: number | string };
export default function AdvancedChart({ symbol = "NASDAQ:AAPL", height = 600 }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) return;
    const s = document.createElement("script");
    s.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    s.async = true;
    s.innerHTML = JSON.stringify({
      autosize: true,
      symbol,
      interval: "D",
      theme: "dark",
      withdateranges: true,
      allow_symbol_change: true,
      details: true,
      hotlist: true,
      calendar: true,
      studies: ["Volume@tv-basicstudies"],
      support_host: "https://www.tradingview.com",
    });
    ref.current.appendChild(s);
    return () => ref.current?.replaceChildren();
  }, [symbol]);
  return (
    <div style={{ height }}>
      <div className="tradingview-widget-container h-full" ref={ref} />
    </div>
  );
}
